import { combineReducers } from 'redux';

import FullStore from "../store/store";

// LocalStorage helper functions
const CART_STORAGE_KEY = 'foodly_cart';

const saveCartToLocalStorage = (items) => {
    try {
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
        console.error('Error saving cart to localStorage:', error);
    }
};

const loadCartFromLocalStorage = () => {
    try {
        const savedCart = localStorage.getItem(CART_STORAGE_KEY);
        if (!savedCart) return [];
        const parsed = JSON.parse(savedCart);
        // migrate old items that have no id
        return parsed.map(item => ({
            ...item,
            id: item.id ?? item.title,
            basket: (item.basket || []).map((f, idx) => ({
                ...f,
                // Old carts keyed features by `${type}-${measure}`, which
                // collided when two lines shared a type+measure. Give each a
                // unique id so edit/delete target exactly one line.
                id: f.id && !/^[^_]+-[^_]+$/.test(f.id)
                    ? f.id
                    : `feat_legacy_${Date.now().toString(36)}_${item.id ?? idx}_${idx}`
            }))
        }));
    } catch (error) {
        console.error('Error loading cart from localStorage:', error);
        return [];
    }
};

export const clearCartFromLocalStorage = () => {
    try {
        localStorage.removeItem(CART_STORAGE_KEY);
    } catch (error) {
        console.error('Error clearing cart from localStorage:', error);
    }
};


const NavBarData = (state = FullStore.NavBarData, action) => {
    return state;
};
const BackgroundAsImageData = (state = FullStore.BackgroundAsImageData, action) => {
    return state;
}
/**
 * 
 export const addToBasket = product => {
  return {
    type: 'ADD-ITEM-TO-BASKET',
    product
  }
}
 */
const EMPTY_TAB_STATE = {
    status: "offline",
    activeTab: FullStore?.TabCardGridData?.activeTab || "Foods",
    heading: FullStore?.TabCardGridData?.heading || "From Our Stocks",
    tabs: { Foods: [], Market: [], Category: [], Featured: [] },
    items: [],
    marketFoods: [],
    featured: []
};

const TabCardGridData = (state = EMPTY_TAB_STATE, action) => {
    // Load cart from localStorage on first initialization
    if (!state.items) {
        const savedItems = loadCartFromLocalStorage();
        state.items = savedItems.length > 0 ? savedItems : [];
    }
    
    if (action.type === 'SET-TAB') {
        return {...state, activeTab: action.to};
    }
    if (action.type === 'FETCH-MAIN-STOCKS') {       
        const Market = action.data || [];        
        const tabs = {...state.tabs, Market};
        const TabCardGridData = {...state, tabs};
        const stockData = Market ? {...TabCardGridData, status: "online"} : {...state, status: "online"};
        return stockData;
    }
    if (action.type === 'FETCH-FOODS') {
        const Foods = action.data || [];
        // Update both tabs.Foods (for marketplace) and marketFoods (for explicit marketplace reads)
        // tabs.Foods is only overridden by FETCH-FEATURED if featured data exists
        return {...state, marketFoods: Foods, tabs: {...state.tabs, Foods}, status: 'online'};
    }
    if (action.type === 'FETCH-MARKET') {
        const Market = action.data || [];
        return {...state, tabs: {...state.tabs, Market}, status: 'online'};
    }
    if (action.type === 'FETCH-FEATURED') {
        // Featured items override tabs.Foods on the homepage only when data actually exists
        // If stocks_featured is empty this action is never dispatched, so tabs.Foods keeps the foods data
        return {...state, featured: action.data, tabs: {...state.tabs, Foods: action.data}};
    }
    if (action.type === 'FETCH-CATEGORY') {
        // Only updates tabs.Category — never touches Foods, Market, or Featured
        const Category = action.data || [];
        return {...state, tabs: {...state.tabs, Category}, status: 'online'};
    }
    if (action.type === 'ADD-ITEM-TO-BASKET') {
        let products = [...state.items]
        let product = {...action?.product}
        if (!product.id) product.id = product.title;

        let newState = {}
        const index = products?.findIndex((item) => item?.id === product?.id || item?.title === product?.title)

        product.total = product.basket.reduce((accumulator, object) => {
            return accumulator + object.total;
          }, 0);

        product.quantity = product.basket.reduce((accumulator, object) => {
            return accumulator + object.quantity;
          }, 0);
        
        if (index !== -1) {
            products[index] = product
            newState = {...state, items: products}
        } else {
            const newProducts = [...state.items, product]
            newState = {...state, items: newProducts}
        }

        // item.quantity = 1
        // item.total = item?.price

        console.log(newState.items)
        saveCartToLocalStorage(newState.items);
        return newState
        
    }
    if (action.type === 'REMOVE-ITEM-FROM-BASKET') {

        let items =  [...state?.items];
        const index = items.findIndex((basketItem) => basketItem.id === action?.product?.id);
  
        
  
        if(index >= 0){
          // The item exist in basket
          items.splice(index, 1);
        } else{
          console.warn(
            `(id : ${action.payload.id}) is not present in the Basket`
          );
        }
        const newState = {...state, items}
        saveCartToLocalStorage(newState.items);
        return newState
    }
    if (action.type === 'CLEAR-BASKET') {
        clearCartFromLocalStorage();
        return {...state, items: []}
    }
    if (action.type === 'REMOVE-BASKET-FEATURE') {
        let items = [...state.items];
        const productIndex = items.findIndex(i => i.id === action.productId || i.title === action.productId);
        if (productIndex >= 0) {
            const updatedBasket = items[productIndex].basket.filter(f => f.id !== action.featureId);
            if (updatedBasket.length === 0) {
                items.splice(productIndex, 1);
            } else {
                items[productIndex] = {
                    ...items[productIndex],
                    basket: updatedBasket,
                    total: updatedBasket.reduce((acc, o) => acc + o.total, 0),
                    quantity: updatedBasket.reduce((acc, o) => acc + o.quantity, 0)
                };
            }
        }
        const newState = {...state, items};
        saveCartToLocalStorage(newState.items);
        return newState;
    }
    if (action.type === 'UPDATE-BASKET-FEATURE-QUANTITY') {
        let items = [...state.items];
        const productIndex = items.findIndex(i => i.id === action.productId || i.title === action.productId);
        if (productIndex >= 0) {
            const qty = Math.max(1, Number(action.quantity));
            const updatedBasket = items[productIndex].basket.map(f =>
                f.id === action.featureId ? {...f, quantity: qty, total: qty * f.price} : f
            );
            items[productIndex] = {
                ...items[productIndex],
                basket: updatedBasket,
                total: updatedBasket.reduce((acc, o) => acc + o.total, 0),
                quantity: updatedBasket.reduce((acc, o) => acc + o.quantity, 0)
            };
        }
        const newState = {...state, items};
        saveCartToLocalStorage(newState.items);
        return newState;
    }
    if (action.type === 'INCREMENT-PRODUCT-QUANTITY') {
        let items = [...state?.items]
        let index = items.findIndex((i) => i.id === action?.product?.id)      
        
        let quantity = items[index]?.quantity
        if (quantity) {
          quantity = Number(quantity) + 1
        } else {
          quantity = 1
        }
        items[index].quantity = quantity
        items[index].total = Number(items[index]?.price) * quantity

        const newState = {...state, items}
        saveCartToLocalStorage(newState.items);
        return newState
    }  
    if (action.type === 'DECREMENT-PRODUCT-QUANTITY') {
        let items = [...state?.items]
        let index = state.items.findIndex((i) => i.id === action?.product?.id)
        let quantity = items[index]?.quantity
        if (quantity>1) {
          quantity = Number(quantity) - 1
        } else {
          quantity = 1
        }
        items[index].quantity = quantity
        items[index].total = Number(items[index]?.price) * quantity
        const newState = {...state, items}
        saveCartToLocalStorage(newState.items);
        return newState;
    }
    return state;    
}
const BuyFormData = (state = FullStore.BuyFormData, action) => {
    return state;
}
const OurBenefitsData = (state = FullStore.OurBenefitsData, action) => {
    return state;
}
const TestimonialsData = (state = FullStore.TestimonialsData, action) => {
    return state;
}
const WelcomeRemarkData = (state = FullStore.WelcomeRemarkData, action) => {
    return state;
}
const SubscribeData = (state = FullStore.SubscribeData, action) => {
    if (action.type === "FETCH-SUBSCRIPTION-REMARK") {
        return {...FullStore.SubscribeData, remark: `Thank You ${action.email} For Subscribing`};
    };
    return state;
}
const DownloadAppData = (state = FullStore.DownloadAppData, action) => {
    return state;
}
const ContactUsData = (state = FullStore.ContactUsData, action) => {
    return state;
}
const BlogData = (state = FullStore.BlogData, action) => {
    return state;
}
const FooterData = (state = FullStore.FooterData, action) => {
    return state;
}
const AboutUsData = (state = FullStore.AboutUsData, action) => {
    return state;
}
const InBlogMarketDisplayData = (state = FullStore.InBlogMarketDisplayData, action) => {
    return state;
};



const rootReducer = combineReducers({   
    NavBarData,
    BackgroundAsImageData,
    TabCardGridData,
    BuyFormData,
    OurBenefitsData,
    TestimonialsData,
    WelcomeRemarkData,
    SubscribeData,
    DownloadAppData,
    ContactUsData,
    BlogData,
    FooterData,
    AboutUsData,
    InBlogMarketDisplayData
});


export default rootReducer;